import { ImageBackground } from "expo-image";
import type { ImageBackgroundProps } from "expo-image/src/Image.types";
import { LinearGradient } from "expo-linear-gradient";
import type { ReactNode } from "react";
import { StyleSheet, View } from "react-native";
import { Title } from "~/components/layout/text";
import { Space } from "~/constants/sizing";
import { useTheme } from "~/providers/ThemeProvider";

export type ResourceCardProps = {
    title: string;
    children: ReactNode;
} & Omit<ImageBackgroundProps, "style" | "children">;

export const ResourceCard = ({
    title,
    children,
    contentFit = "cover",
    contentPosition = "center",
    ...imageProps
}: ResourceCardProps) => {
    const { colours, background } = useTheme();

    return (
        <View style={styles.card}>
            <ImageBackground
                {...imageProps}
                style={styles.header}
                contentFit={contentFit}
                contentPosition={contentPosition}
            >
                <LinearGradient colors={["transparent", colours.background.brand]} style={styles.gradient} />
                <Title>{title}</Title>
            </ImageBackground>
            <View style={[styles.body, background.brand]}>{children}</View>
        </View>
    );
};

const styles = StyleSheet.create({
    card: {
        padding: 0,
        margin: 0,
        alignItems: "stretch",
        justifyContent: "flex-start",
        flexShrink: 0,
        gap: 0,
    },
    gradient: {
        height: 100,
        borderWidth: 0,
        margin: 0,
        position: "absolute",
        zIndex: 0,
        top: 120,
        bottom: 0,
        left: 0,
        right: 0,
    },
    header: {
        position: "relative",
        height: 220,
        justifyContent: "flex-end",
        paddingHorizontal: Space.md,
    },
    body: {
        padding: Space.md,
        gap: Space.lg,
    },
});
